/**
 * Layout Columns Tool for Editor.js
 * Permite crear layouts con 2 o 3 columnas tipo Canva
 */

class LayoutColumns {
    static get toolbox() {
        return {
            title: 'Columnas',
            icon: '<svg width="17" height="14" viewBox="0 0 17 14"><path d="M0 0h7v14H0zM9 0h8v14H9z"/></svg>'
        };
    }

    static get isReadOnlySupported() {
        return true;
    }

    constructor({ data, api, readOnly }) {
        this.api = api;
        this.readOnly = readOnly;
        this.data = {
            columns: data.columns || 2,
            items: data.items || ['', ''],
            style: data.style || 'default'
        };
        this.wrapper = null;
    }

    render() {
        this.wrapper = document.createElement('div');
        this.wrapper.classList.add('layout-columns-wrapper');
        this.wrapper.setAttribute('data-columns', this.data.columns);
        this.wrapper.setAttribute('data-style', this.data.style);

        // Toolbar de configuración
        const toolbar = this.renderToolbar();
        this.wrapper.appendChild(toolbar);

        // Contenedor de columnas
        const columnsContainer = document.createElement('div');
        columnsContainer.classList.add('layout-columns-container');
        
        // Crear columnas
        for (let i = 0; i < this.data.columns; i++) {
            const column = this.createColumn(i);
            columnsContainer.appendChild(column);
        }

        this.wrapper.appendChild(columnsContainer);
        
        return this.wrapper;
    }

    renderToolbar() {
        const toolbar = document.createElement('div');
        toolbar.classList.add('layout-columns-toolbar');

        // Selector de número de columnas
        const columnsSelector = document.createElement('select');
        columnsSelector.innerHTML = `
            <option value="2" ${this.data.columns === 2 ? 'selected' : ''}>2 Columnas</option>
            <option value="3" ${this.data.columns === 3 ? 'selected' : ''}>3 Columnas</option>
        `;
        columnsSelector.addEventListener('change', (e) => {
            this.changeColumns(parseInt(e.target.value));
        });
        
        toolbar.appendChild(columnsSelector);

        // Selector de estilo
        const styleSelector = document.createElement('select');
        styleSelector.innerHTML = `
            <option value="default" ${this.data.style === 'default' ? 'selected' : ''}>Normal</option>
            <option value="bordered" ${this.data.style === 'bordered' ? 'selected' : ''}>Con Bordes</option>
            <option value="shadowed" ${this.data.style === 'shadowed' ? 'selected' : ''}>Con Sombra</option>
            <option value="colored" ${this.data.style === 'colored' ? 'selected' : ''}>Fondo Color</option>
        `;
        styleSelector.addEventListener('change', (e) => {
            this.data.style = e.target.value;
            this.wrapper.setAttribute('data-style', e.target.value);
        });
        
        toolbar.appendChild(styleSelector);

        return toolbar;
    }

    createColumn(index) {
        const column = document.createElement('div');
        column.classList.add('layout-column');
        column.contentEditable = !this.readOnly;
        column.dataset.columnIndex = index;
        column.innerHTML = this.data.items[index] || '';

        column.addEventListener('input', (e) => {
            this.data.items[index] = e.target.innerHTML;
        });

        column.addEventListener('paste', (e) => {
            e.preventDefault();
            const text = e.clipboardData.getData('text/plain');
            document.execCommand('insertText', false, text);
        });

        return column;
    }

    changeColumns(newCount) {
        this.data.columns = newCount;
        
        // Ajustar array de items
        if (newCount > this.data.items.length) {
            // Agregar columnas
            while (this.data.items.length < newCount) {
                this.data.items.push('');
            }
        } else if (newCount < this.data.items.length) {
            // Remover columnas (mantener contenido de las primeras)
            this.data.items = this.data.items.slice(0, newCount);
        }

        // Actualizar atributo
        this.wrapper.setAttribute('data-columns', newCount);
        
        // Re-renderizar solo el contenedor de columnas
        const columnsContainer = this.wrapper.querySelector('.layout-columns-container');
        if (columnsContainer) {
            // Limpiar columnas actuales
            columnsContainer.innerHTML = '';
            
            // Crear nuevas columnas
            for (let i = 0; i < this.data.columns; i++) {
                const column = this.createColumn(i);
                columnsContainer.appendChild(column);
            }
        }
    }

    save() {
        return {
            columns: this.data.columns,
            items: this.data.items,
            style: this.data.style
        };
    }

    static get sanitize() {
        return {
            columns: false,
            items: {
                b: true,
                i: true,
                u: true,
                a: {
                    href: true,
                    target: '_blank'
                },
                br: true,
                strong: true,
                em: true
            },
            style: false
        };
    }
}

export default LayoutColumns;
